import {HiyaHostMaps, HiyaBaseHost, getHost} from '@xc/hiya-host'
import {isNode} from '../index'

export const isProd = ENV === 'production'

export const AutoHost = (() => {
  let host: string
  if (!isNode()) {
    host = window.location.host
  }
  return getHost({
    host,
    env: isProd ? 'prod' : 'test',
    HostMaps: HiyaHostMaps,
  })
})()

export const {
  auto,
  prod,
  replaceAutoHost,
  replaceAutoHostBgImg,
  replaceAutoHostStyle,
} = AutoHost

export const replaceSentryDsn = (dsn: string) => {
  // 不是 mehiya.com
  if (!dsn.includes(HiyaBaseHost.prod.sentry)) {
    return dsn
  }
  // 未配置动态域名
  if (!auto.sentry) {
    return dsn
  }
  return dsn.replace(HiyaBaseHost.prod.sentry, auto.sentry)
}

export const HostMaps = {
  auto: {
    websit: isProd
      ? `https://${auto['me-live-websit']}`
      : `http://${auto['me-live-websit']}`,
    web: isProd ? `https://${auto['hiya-web']}` : `http://${auto['hiya-web']}`,
    activity: isProd ? `https://${auto.activity}` : `http://${auto.activity}`,
    version: isProd ? `https://${auto.version}` : `http://${auto.version}`,
    img01: `http://${auto.img01}`,
    video01: `http://${auto.video01}`,
    otherStatic: `https://${auto['other-static']}`,
    api: isProd ? `https://${auto.api}` : `http://${auto.api}`,
  },
  prod: {
    activity: `https://${prod.activity}`,
    version: `https://${prod.version}`,
    video01: `http://${prod.video01}`,
    img01: `http://${prod.img01}`,
    api: `https://${prod.api}`,
  },
}
